import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEventUserInterface } from '../data/event-user.interface';
import { GtmStatsAdapterList } from './list';

export class GtmStatsAdapterEventUserRegister implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataEventUserInterface[] {
    return [
      {
        event: 'Userbox',
        eventAction: 'Finish:Sign up with Email',
        eventLabel: new GtmStatsAdapterList(this.context).getData(),
      },
    ];
  }
}
